module.exports = __webpack_public_path__ + "img/webdesign.56bcfd32.png";